import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export default class AddButton extends Component {
  static propTypes = { onClick: PropTypes.func };
  render() {
    return <Button {...this.props}>+ ADD LABEL</Button>;
  }
}
const Button = styled.button`
  display: inline-flex;
  vertical-align: top;
  height: auto;
  border-radius: 3px;
  font-size: 0.6rem;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 1px solid ${props => props.theme.headerButtonBorder};
  color: ${props => props.theme.headerButtonBorder};
  background-color: transparent;
  transition: 0.3s;
  cursor: pointer;
  white-space: nowrap;
  padding: 2px 6px;
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
`;



// WEBPACK FOOTER //
// ./src/module-common/label-list/AddButton.js